module.exports = __webpack_public_path__ + "img/144ne.906f893d.svg";